import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function ProductPresentation() {
  const checkoutUrl = 'https://myschoolofbusiness.com/cart/47422073733314:1';
  const benefits = ['Más claridad mental y enfoque durante el día', 'Menos hinchazón abdominal después de comer', 'Mejor descanso y menos despertares nocturnos', 'Más energía estable sin depender del café', 'Menos ansiedad por comer dulces o carbohidratos', 'Una mejor relación y entendimiento de tu cuerpo'];
  return <section className="py-24 px-4 bg-primary-bg" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block mb-4 px-6 py-2 rounded-full bg-accent/10 text-accent-dark font-bold tracking-widest uppercase text-sm" data-id="element-162">
            La Solución
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-text-primary mb-6" data-id="element-163">
            Presentamos: <br className="hidden sm:block" data-id="element-164" />
            <span className="text-health" data-id="element-165">PERI-MENOPAUSIA REBELDE</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-text-primary/80 max-w-3xl mx-auto" data-id="element-166">
            Una guía práctica de 21 días para ayudarte a sentirte más ligera,
            dormir mejor, reducir la inflamación asociada al estilo de vida y
            recuperar tu energía paso a paso.
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-167">
          <motion.div className="flex-1 relative" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-168">
            <div className="relative z-10" data-id="element-169">
              <img src="https://cdn.magicpatterns.com/uploads/iQapRN8y9NN55qNaVV42ua/mock-peri-menopausia.png" alt="Peri-Menopausia Rebelde Ebook" className="w-full h-auto drop-shadow-2xl scale-110 origin-center" data-id="element-170" />
            </div>
            {/* Decorative blob behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-tr from-health/20 to-accent/20 blur-3xl rounded-full -z-10" data-id="element-171"></div>
          </motion.div>

          <motion.div className="flex-1" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-172">
            <h3 className="text-2xl sm:text-3xl font-bold text-text-primary mb-8" data-id="element-173">
              Lo que lograrás en 21 días:
            </h3>

            <ul className="space-y-5 mb-10" data-id="element-174">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-175">
                  <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-health/20 flex items-center justify-center" data-id="element-176">
                    <Check size={14} className="text-health font-bold" data-id="element-177" />
                  </div>
                  <span className="text-lg text-text-primary/80 font-medium" data-id="element-178">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-text-primary hover:bg-text-primary/90 text-white rounded-2xl font-bold text-lg shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 group" data-id="element-179">
              VER LA OFERTA ESPECIAL
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-180" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}